import { useMemo } from 'react';
import { HttpMethod, TaskStatus } from '../enums';

const useTaskOptions = () => {
  const methodsOptions = useMemo(
    () =>
      Object.entries(HttpMethod).map(([key, value]) => ({
        label: value,
        value: key,
      })),
    []
  );

  const tasksStatuses = useMemo(
    () =>
      Object.entries(TaskStatus).map(([key, value]) => ({
        label: value,
        value: key,
      })),
    []
  );

  return { methodsOptions, tasksStatuses };
};

export default useTaskOptions;
